import { ColumnType } from '../types';

import * as Icon from './icons';

export const FIELD_GLYPH_MAP = {
  [ColumnType.CHECKBOX]: Icon.FIELD_CHECKBOX,
  [ColumnType.DATETIME]: Icon.FIELD_DATE,
  [ColumnType.FORMULA]: Icon.FIELD_FORMULA,
  [ColumnType.LONG_TEXT]: Icon.FIELD_LONG_TEXT,
  [ColumnType.MULTI_ATTACHMENT]: Icon.FIELD_ATTACHMENT,
  [ColumnType.MULTI_SELECT]: Icon.FIELD_MULTI_SELECT,
  [ColumnType.NUMBER]: Icon.FIELD_NUMBER,
  [ColumnType.RATING]: Icon.FIELD_RATING,
  [ColumnType.RECORD_REFERENCE]: Icon.FIELD_RECORD_REF,
  [ColumnType.SELECT]: Icon.FIELD_SELECT,
  [ColumnType.TEXT]: Icon.FIELD_TEXT,
  [ColumnType.AUTO_NUMBER]: Icon.FIELD_TEXT,
  [ColumnType.LOOKUP]: Icon.FIELD_LOOKUP,
  [ColumnType.ROLLUP]: Icon.FIELD_ROLLUP,
  [ColumnType.SUBTABLE]:Icon.FIELD_COLLABORATOR
};
